import { render } from "./CustoKeys.vue?vue&type=template&id=036b769a&scoped=true"
import script from "./CustoKeys.vue?vue&type=script&lang=js"
export * from "./CustoKeys.vue?vue&type=script&lang=js"

import "./CustoKeys.vue?vue&type=style&index=0&id=036b769a&scoped=true&lang=css"

import exportComponent from "/tmp/build_2d2f4584/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036b769a"]])

export default __exports__